<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="Dupont Vespel®"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container class="mb-lg-42">
                <h2 class="page-tit mb-18 mb-lg-24">
                    <v-img max-width="386" src="/images/logos/vespel.png" alt="Dupont Vespel" class="mx-auto" />
                    <!-- Dupont Vespel® -->
                </h2>
                <h3 class="tit text-center primary--text">Dupont Vespel® Distributor</h3>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/dupont/dupont-top-img.png"
            className="h-lg-240px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    Highly demanding applications like aerospace components, semiconductor processing, <br class="d-none d-md-block">
                    under the most severe conditions since 1965.
                </h3>
                <p class="page-text color-grey-51">
                    Highly demanding applications like aerospace components, semiconductor processing, <br class="d-none d-md-block">
                    automotive manufacturing, and energy production rely on Vespel® parts to keep their equipment running.
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Advantages">
                    <v-row>
                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon1.png"
                        iconWidth="50"
                        num="01">
                            All manufactured parts are shaped according to customer needs.
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon2.png"
                        iconWidth="38"
                        num="02">
                            It overcomes wear or friction problems, can withstand high temperatures,
                            and can withstand the harshest operating environments.
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon3.png"
                        iconWidth="50"
                        num="03">
                            It can keep production running smoothly and extend the use interval of consumable materials.
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/dupont/dupont-icon4.png"
                        iconWidth="50"
                        num="04">
                            In addition to being simple and practical, you can create lightweight parts  that outperform standard metals, ceramics and other engineering plastics.
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="Vespel®" class="mb-40 mb-lg-60">
                    <p class="page-text color-grey-51 mb-2 mb-lg-6">
                        Vespel® polyimide materials provide continuous operation at cryogenic to high temperatures low wear and low friction at high PV in lubricated or  unlubricated environments outstanding creep, strength, and impact resistance exceptional dimensional stability low thermal expansion and easy machinability. <br>
                        Vespel® makes lighter weight parts not only practical, but, in many cases, better than standard metal, ceramics, and other engineering polymers such as  PEEK (polyether ether ketone) and PAI (polyamide-imide). <br>
                        Vespel® parts and shapes, both custom and stock, have been tested and proven effective in highly demanding applications around the globe.  
                    </p>
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">
                        They are available in <strong class="font-weight-bold color-point">sheet, rod, tube, plaque, bar, disk, ring, ball, and custom machined parts.</strong>
                    </p>
                    <v-row no-gutters>
                        <v-col cols="12" md="6">
                            <table class="client-table client-table-xl w-100 border-md-end">
                                <colgroup>
                                    <col style="width: 25%">
                                    <col style="width: 75%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Grade</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-1</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SP-1 parts and shapes are  specified for their excellent physical properties,  including electrical and thermal insulation at high  temperatures. SP-1 is an unfilled polymer
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-3</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SP-3 parts and shapes are  specified for seals and bearings in vacuum or dry  environments.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-21</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SP-21 parts and shapes provide  low wear and friction for bearing, thrust washers,  and dynamic seals. SP-21 is a graphite-filled  polymer.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-211</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SP-211 parts and shapes have a low  coefficient of friction over a wide range of operating  conditions. It exhibits low wear rates up to 300 °C  (572 °F). SP-211 is a filled polymer.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-2515</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    Parts made from DuPont™ Vespel® SP-2515 offer a low  coefficient of thermal expansion (CTE), excellent wear  against both aluminum and steel alloys, and a low  coefficient of friction in both dry and lubricated conditions.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                        <v-col cols="12" md="6">
                            <table class="client-table client-table--last client-table-xl w-100">
                                <colgroup>
                                    <col style="width: 25%">
                                    <col style="width: 75%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Grade</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-202</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SP-202 contactor pads, rollers, guides,  and lift pin components have high reliability and long life  in high temperature service.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SP-221</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SP-22 parts and shapes provide low wear  and friction for bearings, thrust washers, and dynamic  seals. SP-22 is a filled polymer with a coefficient of thermal  expansion similar to aluminum.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SCP-5000</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SCP-5000 is an unfilled polyimide  polymer that offers high modulus and surface hardness  and improved dimensional stability. Compared to  traditional polyimides, it offers better strength and  stiffness at high temperatures.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SCP-50094</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SCP has higher thermal oxidative  resistance than SP polyimides with superior chemical  resistance. SCP-5009 and SCP-50094 approximates the  CTE of aluminum. Available as stock shapes.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">SCP-5050</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    DuPont™ Vespel® SCP has higher thermal oxidative  resistance than SP polyimides with superior chemical  resistance. SCP-5050 matches the CTE of steel. Available  as custom parts or stock shapes.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                    </v-row>
                </sub-line-layout>

                <inquiry
                src="/images/sub/distributor/dupont/dupont-img1.png"
                name="D.H YOO"
                tel="+82-31-765-2268"
                mail="davidyoo@ist-co.kr"
                fax="+82-31-765-2389"
                link="https://www.dupont.com/vespel.html"
                linkBg="/images/sub/distributor/dupont/dupont-img2.png">
                </inquiry>

            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/en/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/en/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/en/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
    },
};
</script>

<style lang="scss" scoped>
</style>